export const paginationShowSizeChanger = {
  showSearch: false,
};

const basePagination = {
  size: 'small',
  placement: [ 'bottomCenter' ],
  pageSizeOptions: [ '10', '25', '50' ],
  showSizeChanger: paginationShowSizeChanger,
};

export default basePagination;
